import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@/Components/Button/Button';
import Icon from '@/Components/Icon/Icon';
import { useCallback } from 'react';
const SmartViewItem = ({ view, onEdit, onDelete }) => {
    const onClickDelete = useCallback(() => onDelete(view), [onDelete, view]);
    return (_jsxs("div", { className: "flex items-center gap-2 py-1.5", children: [_jsx(Icon, { type: view.iconString, size: "custom", className: "h-5.5 w-5.5 flex-shrink-0" }), _jsx("span", { className: "mr-auto overflow-hidden text-ellipsis text-sm", children: view.title }), _jsx(Button, { small: true, onClick: onEdit, children: "Edit" }), _jsx(Button, { small: true, onClick: onClickDelete, children: "Delete" })] }));
};
export default SmartViewItem;
